const prefix = '@CryptoControlV2';
export const cookies = {
  AUTH_TOKEN: `${prefix}-AUTH-TOKEN`,
  PORTFOLIO_METHOD: `${prefix}-PORTFOLIO-METHOD`,
  PORTFOLIO_CURRENCY: `${prefix}-PORTFOLIO-CURRENCY`,
  PORTFOLIO_WALLETS: `${prefix}-PORTFOLIO-WALLETS`,
  PORTFOLIO_VIEW_VARIANT: `${prefix}-PORTFOLIO-VIEW-VARIANT`,
  RADAR_VIEW_VARIANT: `${prefix}-RADAR-VIEW-VARIANT`,
  FAVORITES_COINS: `${prefix}-FAVORITES-COINS`,
  PORTFOLIO_HIDDEN_COINS: `${prefix}-PORTFOLIO-HIDDEN-COINS`,
  PORTFOLIO_HIDDEN_STOCKS: `${prefix}-PORTFOLIO-HIDDEN-STOCKS`,
  RADAR_VOLUME_ON: `${prefix}-RADAR-VOLUME-ON`,
  RADAR_OPERATION: `${prefix}-RADAR-OPERATION`,
  RADAR_ALERTS: `${prefix}-RADAR-ALERTS`,
  RADAR_GRID_VARIANT: `${prefix}-RADAR-GRID-VARIANT`,
  RADAR_GRID_VARIANT_EMA_SMA_OPTION: `${prefix}-RADAR-GRID-VARIANT-EMA-SMA-OPTION`,
  RADAR_ONLY_FAVORITES: `${prefix}-RADAR-ONLY-FAVORITES`,
  CURRENT_SIDEBAR_POS: `${prefix}-CURRENT-SIDEBAR-POS`,
  RADAR_MOBILE_VIEW: `${prefix}-RADAR-MOBILE-VIEW`,
  MOBILE_RADAR_GRID_VARIANT: `${prefix}-MOBILE-RADAR-GRID-VARIANT`,
  MONEYFLOW_VIEW: `${prefix}-MONEYFLOW-VIEW`,
  MONEYFLOW_CRYPTO: `${prefix}-MONEYFLOW-CRYPTO`,
  MONEYFLOW_EXHIBITION: `${prefix}-MONEYFLOW-EXHIBITION`,
  MONEYFLOW_DISPLAY: `${prefix}-MONEYFLOW-DISPLAY`,
  MONEYFLOW_PERIOD: `${prefix}-MONEYFLOW-PERIOD`,
  PROFITABILITY_ANALYSIS_COINS: `${prefix}-PROFITABILITY-ANALYSIS-COINS`,
  PROFITABILITY_ANALYSIS_STOCKS: `${prefix}-PROFITABILITY-ANALYSIS-STOCKS`,
  GROUP_STOCK_PERFORMANCE_CATEGORIES: `${prefix}-GROUP-STOCK-PERFORMANCE-CATEGORIES`,
};
